module.exports = __webpack_public_path__ + "media/images/flags/AX-fade3d1332ebda188823688eca50f835.svg";